{
    "account": "Konto",
    "add_bookmark": "Bokmerk melding",
    "add_date": "Legg til en dato",
    "ago": "{{duration}} siden",
    "api_key": "API-nøkkel",
    "are_you_sure": "Er du sikker?",
    "ask_delete_message": "Slett meldingen?",
    "audio_not_ready": "Lyden er ikke klar enda.",
    "bookmark_added": "Melding bokmerket.",
    "bookmark_removed": "Meldingsbokmerke fjernet.",
    "bookmarks": "bokmerker",
    "cancel": "Avbryt",
    "cancel_write": "Forkast den nye meldingen?",
    "changed_group_name": "endret gruppenavnet",
    "confirm_password_placeholder": "bekreft",
    "connect": "Tilkobling",
    "create_a_group": "Opprett en gruppe",
    "create_the_group": "Opprett gruppen",
    "daily": "Daglig",
    "default_group": "Forvalgt gruppe",
    "delete": "Slett",
    "destroy_account_explain": "Når du sletter kontoen din er permanent. Vær sikker i din sak.",
    "destroy_account": "Slett kontoen din",
    "edit": "Rediger",
    "email": "E-post",
    "email_input": "Fyll inn e-postadressen din her",
    "empty_message": "Meldingen er tom og kan ikke sendes.",
    "error": "En feil oppstod",
    "error_new_message": "En feil inntraff ved forsendelse av meldingen din.",
    "error_upload": "En feil inntraff under opplasting",
    "forgot_password": "Glemt passordet?",
    "group_left": "Du forlot gruppen.",
    "groups": "Grupper",
    "group_share_choice": "Hvilken gruppe vil du sende denne meldingen til?",
    "group_updated": "Gruppen ble oppdatert.",
    "has_commented_on": "har kommentert",
    "has_joined": "har tatt del i",
    "has_left": "har forlatt",
    "has_posted_in": "har postet i",
    "hourly": "Timevist",
    "in": "i",
    "Invalid login/password": "Ugyldig brukernavn/eller passord",
    "invitation_link": "Invitasjonslenke",
    "invitation_welcome": "Velkommen til Zusam. Registrer deg før du tar del i gruppen.",
    "just_now": "Akkurat nå",
    "lang": "språk",
    "login_input": "Velg innloggingsnavn",
    "login": "Logg inn",
    "login_placeholder": "e-post",
    "logout": "Logg ut",
    "mark_all_as_read": "marker alt som lest",
    "monthly": "Månedlig",
    "multiple_photos_upload": "En feil inntraff. Prøv å laste opp bilder enkeltvis. (Nødvendig i noen nettlesere.)",
    "name_input": "Velg et navn",
    "name": "Navn",
    "new_password_placeholder": "nytt passord",
    "next_coms": "Vis videre kommentarer",
    "none": "Ingen",
    "notification_emails": "E-postmerknader",
    "notification_emails_stopped": "E-postmerknader stoppet!",
    "notifications": "merknader",
    "parent_message": "Inneholdende melding",
    "password_input": "Skriv det nye passordet ditt her",
    "password": "Passord",
    "password_placeholder": "passord",
    "password_reset_mail_sent": "Se etter e-post om tilbakestilling av passord i innboksen din.",
    "passwords_dont_match": "Passordene samsvarer ikke",
    "previous_coms": "Vis tidligere kommentarer",
    "public_link": "offentlig lenke",
    "publish_in_group": "offentliggjør i gruppen",
    "quit_group": "Forlat gruppen",
    "remove_bookmark": "Fjern meldingsbokmerke",
    "replies_one": "{{count}} svar",
    "replies_other": "{{count}} svar",
    "reply": "svar",
    "reset_api_key": "Tilbakestill API-nøkkelen (du vil bli frakoblet)",
    "reset_invitation_link": "Tilbakestill invitasjonslenke",
    "reset_password_title": "Tilbakestill passordet ditt",
    "save_changes": "Lagre endringer",
    "search_in_group": "søk i denne gruppen",
    "search_without_result": "Søket ditt er resultatløst.",
    "settings": "Innstillinger",
    "settings_updated": "Innstillingene dine ble oppdatert",
    "share_message": "del meldingen",
    "signup": "Registrer deg",
    "submit": "Send inn",
    "text_placeholder": "Skriv meldingen din her",
    "the_message_from": "meldingen fra",
    "title_placeholder": "Navn på meldingen (valgfritt)",
    "to": "til",
    "upload_audio": "Legg til en lydfil.",
    "upload_image": "Legg til bilder",
    "upload_music": "Legg til musikk",
    "upload_pdf": "Legg til PDF",
    "upload_video": "Legg til video",
    "User not found": "Fant ikke brukeren",
    "users": "brukere",
    "video_not_ready": "Videoen er ikke klar enda.",
    "weekly": "Ukentlig"
}
